import { StyleSheet, View } from 'react-native';
import { Menu, MenuOption, MenuOptions, MenuTrigger, renderers } from 'react-native-popup-menu';
import { Button, Icon, theme } from '@socrait/react';

type ReviewKebabMenuProps = {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  closeMenu: () => void;
  setIsDeleteReviewModalOpen: (isDeleteReviewModalOpen: boolean) => void;
};

export const ReviewKebabMenu = ({
  isMenuOpen,
  toggleMenu,
  closeMenu,
  setIsDeleteReviewModalOpen,
}: ReviewKebabMenuProps) => {
  return (
    <Menu renderer={renderers.Popover} opened={isMenuOpen} onBackdropPress={closeMenu}>
      <MenuTrigger onPress={toggleMenu}>
        <View style={styles.kebabContainer}>
          <Icon type="kebab" height={theme.spacing.large} width={theme.spacing.large} />
        </View>
      </MenuTrigger>
      <MenuOptions
        customStyles={{
          optionsContainer: {
            background: 'none',
            boxShadow: 'none',
          },
        }}>
        <MenuOption>
          <Button
            icon="delete"
            name="Delete class data"
            containerStyle={{ boxShadow: `2px 2px 6px -1px ${theme.colors.shadow}` }}
            onPress={() => {
              setIsDeleteReviewModalOpen(true);
              closeMenu();
            }}
          />
        </MenuOption>
      </MenuOptions>
    </Menu>
  );
};

const styles = StyleSheet.create({
  kebabContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
